<header class="header__1 js-header">
    <div class="container">
        <div class="wrapper js-header-wrapper">
            <div class="header__logo">
                <a href="">
                    <img class="header__logo"
                    src="assets/img/logos/logoQueezme.png"
                        alt="logo" />
                </a>
            </div>
            <div class="header__menu">
                <ul class="d-flex space-x-20">
                    <li class="has_popup">
                        <a class="color_black"  href="/home#about">About</a>
                    </li>
                    <li> <a class="color_black"  href="/home#token"> Token</a>
                    </li>
                    <li> <a class="color_black"  href="/home#contribute"> Contribute</a> </li>
                    <li> <a class="color_black"  href="/home#whitepaper"> Whitepaper</a>
                    </li>
                    <li> <a class="color_black"  href="/home#roadmap"> Roadmap</a>
                    </li>
                   
                    <li> <a class="color_black"  href="/home#team"> Team</a>
                    </li>
                    <li> <a class="color_black"  href="/home#techno"> Technologies</a>
                    </li>
                </ul>
            </div>
            <div class="">
                <!-- <input type="text" placeholder="Search" />
                <button class="header__result">
                    <i class="ri-search-line"></i>
                </button> -->
            </div>
            <div class="header__btns">
                <!-- <a class="btn btn-grad btn-sm"
                    href="Connect-wallet.html">Connect
                    wallet</a> -->
            </div>
            <div class="header__burger js-header-burger"></div>

            <div class="header__mobile js-header-mobile">
            	<div class="header__mobile__menu space-y-40">
            		<ul class="d-flex space-y-20">
            			<li> <a class="color_black"  href="/home#about"> About</a> </li>
                        <li> <a class="color_black"  href="/home#token"> Token</a>
                        </li>
                        <li> <a class="color_black"  href="/home#contribute"> Contribute</a> </li>
            			<li> <a class="color_black"  href="/home#whitepaper"> Whitepaper</a> </li>
            			<li> <a class="color_black"  href="/home#roadmap"> Roadmap</a> </li>
            			
            			<li> <a class="color_black"  href="/home#team"> Team</a> </li>
                        <li> <a class="color_black"  href="/home#techno"> Technologies</a>
                        </li>
            		</ul>
            		<div class="space-y-20">
            			<!-- <div class="header__search in_mobile w-full">
            			 
            			</div> -->
            			 
            		</div>
            	</div>
            </div>
        </div>
    </div>
</header>
		